import React from "react";

/**
 * Global legal disclosure — rendered at the absolute bottom of every page.
 * Two tiers:
 *  (a) Standard copyright + informational disclaimer (11px)
 *  (b) App-store compliance safety net: Government Affiliation + Financial
 *      Services Policy (12px / 0.75rem, low-contrast)
 */
const LegalDisclosure = () => {
  return (
    <div
      className="w-full"
      data-testid="legal-disclosure"
      style={{
        background: "#071A35",
        borderTop: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      {/* Tier 1 — copyright + product informational disclaimer */}
      <div
        className="text-center px-6 pt-6 pb-3 text-[11px] leading-relaxed"
        style={{ color: "rgba(255,255,255,0.55)" }}
        data-testid="legal-tier-primary"
      >
        <div className="mx-auto max-w-4xl space-y-2">
          <p>
            © 2026 FetchDay LLC. All rights reserved. SpendNova™ is a trademark
            of FetchDay LLC.
          </p>
          <p>
            SpendNova™ is a financial planning and budgeting application designed
            to help users make informed spending decisions. SpendNova does not
            provide financial, investment, tax, or legal advice. AI-generated
            insights are provided for informational purposes only.
          </p>
        </div>
      </div>

      {/* Tier 2 — App Store / Play Store compliance safety net */}
      <div
        className="text-center px-6 pt-2 pb-6 leading-relaxed"
        style={{
          color: "rgba(255,255,255,0.42)",
          fontSize: "0.75rem",
        }}
        data-testid="legal-tier-compliance"
      >
        <div className="mx-auto max-w-4xl space-y-3">
          <p data-testid="legal-gov-affiliation">
            SpendNova™ is a privately owned commercial utility and is an
            independent planning tool. It is NOT an official product of,
            endorsed by, or affiliated with the Department of Defense (DoD),
            any United States military service branch, or the U.S. Government.
          </p>
          <p data-testid="legal-financial-policy">
            SpendNova™ functions strictly as an informational and mathematical
            calculator for military allowance parameters. This application does
            not handle active banking transactions, issue credit, manage real
            money deposits, process official government forms, or link to
            federal financial networks.
          </p>
          <p data-testid="legal-regulatory-compliance">
            SpendNova™ provides informational routing and financial estimates.
            We do not provide DOT compliance advice or official tax preparation
            services. Users must verify all commercial routing and tax filings
            with official sources.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LegalDisclosure;
